/**
 * @author       Pavlo Androshchuk
 * @copyright    Copyright (c) 2022, Zumper
 */

import { PropertyType, getEnumTitle } from '@zcode/enums'
import { capitalize } from '@zcode/utils'
import React from 'react'

export interface Props {
  propertyType: PropertyType
  dateAvailable?: string
  verticalsArray?: string[]
}

const EXCLUDED_PROPERTY_TYPES = [
  PropertyType.APARTMENT_CONDO_TOWNHOUSE,
  PropertyType.FLOOR_PLAN,
  PropertyType.INCOME_INVESTMENT,
  PropertyType.MOBILE_MANUFACTURED,
  PropertyType.TIC,
  PropertyType.UNKNOWN,
]

export const OverlayModifierText = ({ propertyType, dateAvailable, verticalsArray }: Props) => {
  let textParts: string[] = []

  if (verticalsArray?.[0]) {
    textParts.push(capitalize(verticalsArray[0]))
  }
  const propertyTypeTitle = propertyType ? getEnumTitle(PropertyType, propertyType) : ''
  if (propertyTypeTitle && !EXCLUDED_PROPERTY_TYPES.includes(propertyType)) {
    textParts.push(`${propertyTypeTitle} for Rent`)
  }
  textParts = [textParts.join(' ')]

  if (dateAvailable) {
    textParts.push(`Available ${dateAvailable}`)
  }

  const text = textParts.join(' • ')
  if (!text) {
    return null
  }

  return <div className="text-gray-600 text-sm mt-1">{text}</div>
}
